module.exports = __webpack_public_path__ + "static/media/icomoon.0ae79706.woff";